"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    max-width: ", ";\n"], ["\n    width: 100%;\n    max-width: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = require("react-datepicker");

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../../functions");

var _label = require("../label");

var _label2 = _interopRequireDefault(_label);

var _DatePickerInputField = require("./DatePickerInputField");

var _DatePickerInputField2 = _interopRequireDefault(_DatePickerInputField);

var _CalendarContainer = require("./CalendarContainer");

var _CalendarContainer2 = _interopRequireDefault(_CalendarContainer);

var _inputError = require("../inputError");

var _inputError2 = _interopRequireDefault(_inputError);

require("react-datepicker/dist/react-datepicker.css");

require("./datePicker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DATE_FORMAT = "DD/MM/YYYY";
var DatePickerContainer = _styledComponents2.default.div(_templateObject, function (props) {
    return props.expanded ? "100%" : "100%";
});

var DatePicker = function (_Component) {
    _inherits(DatePicker, _Component);

    function DatePicker(props) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        _this.render = function () {
            var field = _this.props;
            return _react2.default.createElement(
                DatePickerContainer,
                null,
                _this.props.label && _react2.default.createElement(
                    _label2.default,
                    field,
                    _this.props.label
                ),
                _this.props.easyRead && _react2.default.createElement(
                    "b",
                    null,
                    _this.props.easyRead
                ),
                _react2.default.createElement(_reactDatepicker2.default, _extends({}, field, {
                    customInput: _react2.default.createElement(_DatePickerInputField2.default, null),
                    dateFormat: DATE_FORMAT,
                    selected: _this.state.selectedDate,
                    onChange: _this.handleChange.bind(_this),
                    className: "form-control " + (field.error ? "alert" : ""),
                    popperContainer: _CalendarContainer2.default,
                    popperClassName: "showInFront"
                })),
                _react2.default.createElement(_inputError2.default, { error: field.error })
            );
        };

        _this.state = {
            selectedDate: (0, _moment2.default)()
        };
        return _this;
    }

    _createClass(DatePicker, [{
        key: "componentDidMount",
        value: function componentDidMount(props) {
            var initialValue = this.props.initialValue;


            if (/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/i.exec(initialValue)) {
                this.handleChange((0, _moment2.default)(initialValue, DATE_FORMAT));
            }
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) {
                this.setState({
                    selectedDate: _moment2.default.isMoment(nextProps.value) ? nextProps.value : (0, _moment2.default)(nextProps.value, DATE_FORMAT)
                });
            }
        }
    }, {
        key: "handleChange",
        value: function handleChange(date) {
            this.setState({
                selectedDate: date
            });
            var newDate = date === null ? "" : date.format(DATE_FORMAT);
            return this.props.onChange({ name: this.props.name, value: newDate });
        }
    }]);

    return DatePicker;
}(_react.Component);

DatePicker.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.any.isRequired,
    initialValue: _propTypes2.default.any,
    size: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    inlineLabel: _propTypes2.default.bool,
    input: _propTypes2.default.object,
    label: _propTypes2.default.string,
    emptyOption: _propTypes2.default.string,
    error: _propTypes2.default.string
};
DatePicker.defaultProps = {
    error: "",
    expanded: true
};
exports.default = DatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/datePicker/DatePicker.js
// module id = 1000
// module chunks = 95715928098905 168707334958949